import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  analyticsApiRef,
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { techRadarApiRef } from '@backstage/plugin-tech-radar';

import { CobliTechRadarApi } from './radar/cobliRadar';

import { Mixpanel } from '@internal/plugin-analytics-module-mixpanel';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory(techRadarApiRef, new CobliTechRadarApi()),
  createApiFactory({
    api: analyticsApiRef,
    deps: {configApi: configApiRef, identityApi: identityApiRef, discoveryApi: discoveryApiRef},
    factory: ({ configApi, identityApi, discoveryApi }) =>
      Mixpanel.fromConfig(configApi, {identityApi, discoveryApi})
  })

];
